<template>
  <div>
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="消息标题">
        <el-input size="medium" clearable v-model="enquiryForm.title" placeholder="请输入消息标题"></el-input>
      </el-form-item>
      <el-form-item label="消息内容">
        <el-input size="medium" clearable v-model="enquiryForm.content" placeholder="请输入消息内容"></el-input>
      </el-form-item>

    </el-form>
    <div style="margin-bottom: 10px">
      <!-- 按钮部分 -->
      <el-button size="medium" type="primary" style="font-size: 12px;"
                 @click="handleSearch(enquiryForm)">查询
      </el-button>
      <el-button size="medium"  style="font-size: 12px;"
                 @click="Reset(enquiryForm)">重置
      </el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;"
                 @click="exportData">导出
      </el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;"
                 @click="printEvent()"> 打印
      </el-button>
    </div>
    <!--表格部分-->
    <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
        v-loading="loading"
        border
        id="tableDataId"
        size="mini"
    >
      <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="ID"
          sortable>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="type"
          label="消息类型">
        <template slot-scope="scope">{{ scope.row.type.text }}</template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="title"
          label="消息标题">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="content"
          label="消息内容">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="send_time"
          label="发送时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="sender"
          label="发送人">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="recipient"
          label="接收人">
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[20,50,100,200,500,1000]"
        :page-size="page_size"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="text-align: right"
    ></el-pagination>
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
  </div>
</template>

<script>
import {export_json_to_excel} from "@/excel/Export2Excel";
import prints from '@/components/print.vue';

export default {
  name: "message",
  components: {
    prints
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      total: 0,  //总数
      page_size: 20, //条数
      // 表格数据
      tableData: [],
      enquiryForm: {
        page: 1,
        page_size: 20,
        type: 1,
        title: '',
        content: '',
        read_status: ''
      },
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm)
    this.tableTh = ['ID', '消息类型', '消息标题', '消息内容', '发送时间', '发送人', '接收人'];
    this.tableTd = ['id', 'type_text', 'title', 'content', 'send_time', 'sender', 'recipient'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.title = ''; //消息标题
      searchForm.content = ''; //消息内容
      searchForm.page = 1;
      searchForm.type = 1;
      this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/message/messageList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },
    // 导出
    exportData() {
      let th = ['ID', '消息类型', '消息标题', '消息内容', '发送时间', '发送人', '接收人'];
      let excelData = ['id', 'type_text', 'title', 'content', 'send_time', 'sender', 'recipient'];
      this.tableData.forEach(item => { //消息类型转换文本
        item.type_text = item.type.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    //打印
    printEvent() {
      this.tableData.forEach(item => { //消息类型转换文本
        item.type_text = item.type.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
  },
}
</script>

<style scoped>

</style>